// @flow
// This file will replace the `device.js` once we get rid of the devices font icons
// The below constants naming convention closely follows the same names of the svg icons from design
// however for some devices, the names were incorrect and renamed, the original names as per the svg icons by design
// have been put in comments so we can easily match the svgs if there are any updates.
const devicesIcons = {
    ACTIVE_BUTTON: 'ACTIVE_BUTTON',
    APPLIANCE: 'APPLIANCE',
    BOILER_MODULE_SLR1: 'BOILER_MODULE_SLR1', //RECEIVER_SINGLE
    BOILER_MODULE_SLR2: 'BOILER_MODULE_SLR2', //RECEIVER_DUAL
    BUTTON_OFF: 'BUTTON_OFF',
    CAMERA_DEHARO: 'CAMERA_DEHARO',
    CAMERA_OFF: 'CAMERA_OFF',
    COLOUR_PICKER: 'COLOUR_PICKER',
    COOLING: 'COOLING',
    DOOR_SENSOR: 'DOOR_SENSOR',
    DOUBLE_TAP: 'DOUBLE_TAP',
    DUO_SOCKET_EU: 'DUO_SOCKET_EU',
    DUO_SOCKET_IN: 'DUO_SOCKET_IN',
    DUO_SOCKET_NA: 'DUO_SOCKET_NA',
    DUO_SOCKET_UK: 'DUO_SOCKET_UK',
    FAN_OFF: 'FAN_OFF',
    FAN_ON: 'FAN_ON',
    FLAME_NA: 'FLAME_NA',
    GENERIC_TEMP: 'GENERIC_TEMP',
    GROUP_CONTROL: 'GROUP_CONTROL',
    HEATING: 'HEATING',
    HIVE_BUTTON: 'HIVE_BUTTON',
    HOT_WATER: 'HOT_WATER',
    HOT_WATER_ON: 'HOT_WATER_ON',
    HUB_NANO1: 'HUB_NANO1', //HUB_NANO
    HUB_NANO2: 'HUB_NANO2', //NANO3
    HUMIDITY: 'HUMIDITY',
    LEAK_SENSOR: 'LEAK_SENSOR',
    LIGHT: 'LIGHT',
    LIGHT_DOUBLE: 'LIGHT_DOUBLE',
    LINK_BROKEN: 'LINK_BROKEN',
    LINKED: 'LINKED',
    LONG_PRESS: 'LONG_PRESS',
    MOTION_SENSOR: 'MOTION_SENSOR',
    ONE_TAP: 'ONE_TAP',
    PHILIPS_HUE_BRIDGE: 'PHILIPS_HUE_BRIDGE',
    PLUG_EU: 'PLUG_EU',
    PLUG_IN: 'PLUG_IN',
    PLUG_NA: 'PLUG_NA',
    PLUG_UK: 'PLUG_UK',
    SENSE: 'SENSE',
    SIGNAL_BOOST: 'SIGNAL_BOOST',
    SIGNAL_BOOSTER_PLUG: 'SIGNAL_BOOSTER_PLUG',
    SOCKET_EU: 'SOCKET_EU',
    SOCKET_IN: 'SOCKET_IN',
    SOCKET_NA: 'SOCKET_NA',
    SOCKET_UK: 'SOCKET_UK',
    SWITCH: 'SWITCH',
    TANKS: 'TANKS',
    THERMOSTAT_SLT1: 'THERMOSTAT_SLT1', //STAT1
    THERMOSTAT_SLT2: 'THERMOSTAT_SLT2', //STAT2
    THERMOSTAT_SLT3: 'THERMOSTAT_SLT3', //STAT3
    TOILETS: 'TOILETS',
    WATER_FLOWING: 'WATER_FLOWING',
    WATER_NOT_FLOWING: 'WATER_NOT_FLOWING'
};

export default devicesIcons;
export type DevicesIcon = $Keys<typeof devicesIcons>;



// WEBPACK FOOTER //
// ./src/core/constants/icons/devices-svg.js